$(document).ready(function () {

    /***********************Contact Map Change******************************************/
    var addressArr = $('.contact_address').find('.blurb');
    $(addressArr).each(function () {
        $(this).on('click', function () {
            var currThumb = '#thumb_' + $(this).attr('id');
            var currAddress = '#map_' + $(this).attr('id');
            $('.gmap_iframe').css({ display: 'none' });
            $(currAddress).fadeIn(100);
            $('.address_thumb img').css({ display: 'none' });
            $(currThumb).fadeIn(100);
        });
    });

    $('.contact_address .card_blurb').slick({
        slidesToShow: 2,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        autoplay: false,
        infinite: false,
        speed: 400,
        responsive: [
            {
                breakpoint: 10000,
                settings: "unslick"
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                }
            }
        ]
    });
});